<template>
  <el-dialog
    class="dialog"
    title="渠道无忧 • 客户问卷调查"
    :visible.sync="dialog"
    center
    width="800px">
    <el-form class="queForm" label-width="200px" :model="queForm" ref="queForm" :rules="rules">
      <h3>一、企业详情</h3>
      <el-form-item label="姓名" prop="contacts" :rules="[{required: true, message: '必填'}]">
        <el-input v-model="queForm.contacts"></el-input>
      </el-form-item>
      <el-form-item label="手机" prop="mobile" :rules="[{required: true, message: '请输入手机号', trigger: ['change', 'blur']},
          {pattern: /^[1][3,4,5,6,7,8,9][0-9]{9}$/, message: '格式不正确', trigger: ['blur', 'change']}]">
        <el-input v-model="queForm.mobile"></el-input>
      </el-form-item>
      <el-form-item label="推广项目名称" prop="itemName" :rules="[{required: true, message: '必填'}]">
        <el-input v-model="queForm.itemName"></el-input>
      </el-form-item>
      <el-form-item label="公司官方网址" prop="webSite">
        <el-input v-model="queForm.webSite">
          <template slot="prepend">Http://</template>
        </el-input>
      </el-form-item>
      <el-form-item label="公司成立时间" prop="regtime">
        <el-input v-model="queForm.regtime" placeholder="如：2010-12-08"></el-input>
      </el-form-item>
      <el-form-item label="公司旗下品牌" prop="brands">
        <el-input v-model="queForm.brands"></el-input>
      </el-form-item>
      <el-form-item label="该项目已推广" prop="popularizeTimeSpan">
        <el-input v-model="queForm.popularizeTimeSpan" placeholder="多长时间"></el-input>
      </el-form-item>
      <el-form-item label="是否有分公司" prop="filiale">
        <el-radio-group v-model="queForm.filiale">
          <el-radio :label="0">没有</el-radio>
          <el-radio :label="1">有</el-radio>
        </el-radio-group>
      </el-form-item>
      <el-form-item label="分公司所在城市" prop="filialeCitys" v-if="queForm.filiale !== 0">
        <el-input v-model="queForm.filialeCitys" placeholder="多个请以逗号隔开"></el-input>
      </el-form-item>
      <el-form-item label="对外宣传" prop="cooperantShop" :rules="[{ min: 1, max: 5, message: '长度在 1 到 5 个字符', trigger: 'blur' }]">
        <el-input v-model="queForm.cooperantShop">
          <template slot="prepend">公司目前有</template>
          <template slot="append">家加盟店</template>
        </el-input>
        <span v-if="queForm.cooperantShop > 0 || queForm.cooperantShop === undefined || queForm.cooperantShop === ''"></span>
        <span v-else style="color:#F56C6C;font-size: 12px">数值必须大于0</span>
      </el-form-item>
      <el-form-item label="项目招商团队" prop="teamPeople" :rules="[{ min: 1, max: 5, message: '长度在 1 到 5 个字符', trigger: 'blur' }]">
        <el-input v-model="queForm.teamPeople">
          <template slot="prepend">有</template>
          <template slot="append">人</template>
        </el-input>
        <span v-if="queForm.teamPeople > 0 || queForm.teamPeople === undefined || queForm.teamPeople === ''"></span>
        <span v-else style="color:#F56C6C;font-size: 12px">数值必须大于0</span>
      </el-form-item>
      <el-form-item label="需要我们提供多少资源量" prop="dailyMinResource" :rules="[ { required: true, message: '请输入数字', trigger: 'blur'},
      { min: 1, max: 8, message: '长度在 1 到 8 个字符', trigger: 'blur' }]">
        <el-input v-model="queForm.dailyMinResource">
          <template slot="append">条</template>
        </el-input>
        <span v-if="queForm.dailyMinResource > 0 || queForm.dailyMinResource === undefined || queForm.dailyMinResource === ''"></span>
        <span v-else style="color:#F56C6C;font-size: 12px">数值必须大于0</span>
      </el-form-item>
      <el-form-item label="是否有完善的在线客服部门" prop="onlineService"
                    :rules="[{required: true, message: '必填'}]">
        <el-radio-group v-model="queForm.onlineService">
          <el-radio :label="0">没有</el-radio>
          <el-radio :label="1">有</el-radio>
        </el-radio-group>
      </el-form-item>
      <el-form-item label="公司的来访率大概是" prop="visitingRate">
        <el-input v-model="queForm.visitingRate">
          <template slot="append">%</template>
        </el-input>
        <span v-if="(queForm.visitingRate > 0 && queForm.visitingRate < 100.00000000001) || queForm.visitingRate === undefined || queForm.visitingRate === ''"></span>
        <span v-else style="color:#F56C6C;font-size: 12px">数值必须大于0小于100</span>
      </el-form-item>
      <el-form-item label="签单百分比大概是" prop="closeRate">
        <el-input v-model="queForm.closeRate">
          <template slot="append">%</template>
        </el-input>
        <span v-if="(queForm.closeRate > 0 && queForm.closeRate < 100.0000001) || queForm.closeRate === undefined || queForm.closeRate === ''"></span>
        <span v-else style="color:#F56C6C;font-size: 12px">数值必须大于0小于100</span>
      </el-form-item>
      <h3>二、品牌定位</h3>
      <el-form-item label="项目的定位是什么？" prop="productOrientation"
                    :rules="[{required: true, message: '必填'}]">
        <el-input v-model="queForm.productOrientation"></el-input>
      </el-form-item>
      <el-form-item label="项目有哪些产品系列？" prop="products" :rules="[{required: true, message: '必填'}]">
        <el-input v-model="queForm.products"></el-input>
      </el-form-item>
      <el-form-item label="加盟商的男女比例" prop="genderRation">
        <el-input v-model="queForm.genderRation" placeholder="如：6:4"></el-input>
      </el-form-item>
      <el-form-item label="年龄段主要以" prop="ageSegment">
        <el-input v-model="queForm.ageSegment" placeholder="如：12-20岁，80后，大学生">
          <template slot="append">为主</template>
        </el-input>
      </el-form-item>
      <el-form-item label="核心竞争优势及主要卖点是什么？（比如免加盟费、赠送装修等）" prop="advantage">
        <el-input v-model="queForm.advantage" placeholder="多个请以逗号隔开"></el-input>
      </el-form-item>
      <!--<el-form-item label="正在使用的招商页面地址" prop="joinWebSite" :rules="[{required: true, message: '必填'}]">-->
      <!--<el-input v-model="queForm.joinWebSite">-->
      <!--<template slot="prepend">http://</template>-->
      <!--</el-input>-->
      <!--</el-form-item>-->
      <el-form-item label="投资最低金额" prop="minInvestment" :rules="[{ min: 1, max: 12, message: '长度在 1 到 12 个字符', trigger: 'blur' }]">
        <el-input v-model="queForm.minInvestment">
          <template slot="prepend">最低</template>
          <template slot="append">元</template>
        </el-input>
        <span v-if="queForm.minInvestment > 0 || queForm.minInvestment === undefined || queForm.minInvestment === ''"></span>
        <span v-else style="color:#F56C6C;font-size: 12px">数值必须是大于0的数字</span>
      </el-form-item>
      <el-form-item label="投资最高金额" prop="maxInvestment" :rules="[{ min: 1, max: 12, message: '长度在 1 到 12 个字符', trigger: 'blur' }]">
        <el-input v-model="queForm.maxInvestment">
          <template slot="prepend">最高</template>
          <template slot="append">元</template>
        </el-input>
        <template>
          <span v-if="queForm.maxInvestment > 0 || queForm.maxInvestment === undefined || queForm.maxInvestment === ''"></span>
          <span v-else style="color:#F56C6C;font-size: 12px">数值必须是大于0的数字</span>
        </template>
        <template>
          <span v-if="queForm.maxInvestment > queForm.minInvestment ||
          queForm.maxInvestment === '' || queForm.minInvestment === '' ||
          queForm.maxInvestment === undefined || queForm.minInvestment === undefined"></span>
          <span v-else style="color:#F56C6C;font-size: 12px">最高金额不能低于最低金额，请重新输入</span>
        </template>
      </el-form-item>
      <el-form-item label="更加详细的加盟政策" prop="joinPolicy">
        <el-input v-model="queForm.joinPolicy" type="textarea"></el-input>
      </el-form-item>
      <el-form-item label="公司主要的竞争对手有哪些？" prop="competitor" :rules="[{required: true, message: '必填'}]">
        <el-input v-model="queForm.competitor" placeholder="多个请以逗号隔开"></el-input>
      </el-form-item>
      <el-form-item label="同行业中，正在使用电视广告或者曾经使用过电视广告的有" prop="tvCompetitor">
        <el-input v-model="queForm.tvCompetitor" placeholder="多个请以逗号隔开"></el-input>
      </el-form-item>
      <el-form-item>
        <div class="str-btn">
          <el-button type="primary" @click="queSurvey()" class="submit">提交</el-button>
          <el-button type="text" @click="resetForm('queForm')">重置</el-button>
        </div>
      </el-form-item>
    </el-form>
  </el-dialog>
</template>
<script>
  import Api from '@/api/tourist/strategy-survey'
  import { QueArgument } from '@/models/tourist/questionnaire'
  export default {
    data () {
      return {
        queForm: new QueArgument(),
        loading: false,
        list: [],
        dialog: false
      }
    },
    created () {},
    methods: {
      open () {
        this.dialog = true
      },
      close () {
        this.dialog = false
      },
      resetForm (queForm) {
        this.$refs[queForm].resetFields()
      },
      queSurvey () {
        let form = this.queForm
        let max = form.maxInvestment
        let min = form.minInvestment
        let daily = form.dailyMinResource
        let visitingRate = form.visitingRate
        let closeRate = form.closeRate
        this.$refs['queForm'].validate((valid) => {
          if (valid) {
            if (max > min || daily > 0 || (visitingRate > 0 && visitingRate < 100.00000000001) || (closeRate > 0 && closeRate < 100.00000000001)) {
              if (this.$store.state.user.info !== null) {
                Api.questLogin({form: form}, response => {
                  let status = response.status || 0
                  let body = response.data || []
                  if (status >= 200 && status <= 204) {
                    // 新数据加到数组开头
                    this.list.unshift(body)
                    this.$message.success('新增成功')
                  } else {
                    this.$message.error(body.error || '新增失败')
                  }
                  this.dialog = false
                })
              } else {
                Api.quest({form: form}, response => {
                  let status = response.status || 0
                  let body = response.data || []
                  if (status >= 200 && status <= 204) {
                    // 新数据加到数组开头
                    this.list.unshift(body)
                    this.$message.success('新增成功')
                  } else {
                    this.$message.error(body.error || '新增失败')
                  }
                  this.dialog = false
                })
              }
            } else {
              this.$message.error('新增失败')
            }
          } else {
            return false
          }
        })
      }
    }
  }
</script>
<style scoped lang="scss">
  .dialog{
    .str-btn{
      width: 100%;
      height: 100%;
      padding-left: 100px;
      box-sizing: border-box;
      .submit{
        width: 140px;
        height: 40px;
        background:#085ECC;
        border: none;
        outline: none;
        margin-right: 20px;
      }
    }
  }
</style>



// WEBPACK FOOTER //
// src/components/tourist/common/Questionnaire.vue